﻿import {
    onErrorAction,
    hideSpinner,
    showErrorDiv,
    toggleUpdateNextToTryAgainandNextButton,    
    showSpinner
} from "./ui.js"
import { unknownErrorMessage } from "./constants.js"

export enum AuthenticationMethod {
    Email = "email",
    Phone = "phone",
    Pin = "pin"
};

export enum OtpVerificationMode {
    Email = "email",
    Sms = "sms"
};

export async function getBalanceAsync(accountNumber: string) {
    const errorMessageDiv = document.getElementById("errMessage") as HTMLDivElement;
    const spinnerDiv = document.getElementById("spinner") as HTMLDivElement;
    const payload = { accountnumber: accountNumber };
    const apiUrl = '/api/Balance';
    const contentTypeKey = "Content-Type";
    const RequestVerificationTokenKey = "RequestVerificationToken";
    const tokenElement = document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement;
    let token = tokenElement.value;
    let headers = new Headers();
    headers.append(contentTypeKey, "application/json");
    headers.append(RequestVerificationTokenKey, token);

    try {
        await refreshAntiForgeryTokenAsync();

        const response = await fetch(apiUrl, {
            method: 'post',
            headers: headers,
            body: JSON.stringify(payload)
        });

        if (response.ok) {
            const responsedata = await response.json();
            const redirectUrlKey = "redirectUrl";
            hideSpinner(spinnerDiv);

            if (redirectUrlKey in responsedata) {
                window.location.href = responsedata[redirectUrlKey];
            }
            else {
                showErrorDiv(errorMessageDiv, unknownErrorMessage);
            }
        }
        else {
            hideSpinner(spinnerDiv);
            const responsedata = await response.json();
            const controllerApiErrorKey = "controllerApiError";
            var errorMessage;

            if (controllerApiErrorKey in responsedata) {
                errorMessage = responsedata[controllerApiErrorKey];
            }
            else {
                errorMessage = unknownErrorMessage;
            }

            showErrorDiv(errorMessageDiv, errorMessage);
        }
    }
    catch (error) {
        hideSpinner(spinnerDiv);
        showErrorDiv(errorMessageDiv, unknownErrorMessage);
    }
}

export async function getAccountVerificationTypeAsync(billingAccount: string): Promise<string[]> {
    let accountVerificationType;

    try {
        const payload = { billingAccount: billingAccount };
        const apiUrl = '/api/mfa/AuthMethod'
        const contentTypeKey = "Content-Type";
        const RequestVerificationTokenKey = "RequestVerificationToken";
        const tokenElement = document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement;
        let token = tokenElement.value;
        let headers = new Headers();
        headers.append(contentTypeKey, "application/json");
        headers.append(RequestVerificationTokenKey, token);

        const response = await fetch(apiUrl, {
            method: 'post',
            headers: headers,
            body: JSON.stringify(payload)
        });

        if (response.ok) {
            const responsedata = await response.json();
            accountVerificationType = responsedata.authMethods;
        }
        else {
            const responsedata = await response.json();
            const controllerApiErrorKey = "controllerApiError";

            if (controllerApiErrorKey in responsedata) {
                const errorMessage = responsedata[controllerApiErrorKey];
                onErrorAction(errorMessage);
            }
            else {
                const spinnerDiv = document.getElementById("spinner") as HTMLDivElement;
                hideSpinner(spinnerDiv);
                const errorMessageUnableToVerify = document.getElementById("errorMessageUnableToVerify") as HTMLDivElement;
                errorMessageUnableToVerify.classList.remove("hide");
                toggleUpdateNextToTryAgainandNextButton();
            }
        }
    }
    catch (error) {
        console.error('Error:', error);
    }

    return accountVerificationType;
}

export async function sendVerificationCodeAsync(billingAccount: string, authMethod: string): Promise<boolean> {
    let isOtpSent = false;
    const spinnerDiv = document.getElementById("spinner") as HTMLDivElement;
    showSpinner(spinnerDiv);
  
    try {
        const payload = {
            BillingAccountNumber: billingAccount,
            OtpVerificationMode: authMethod
        };
        const apiUrl = '/api/mfa/OtpChallenge'
        const contentTypeKey = "Content-Type";
        const RequestVerificationTokenKey = "RequestVerificationToken";
        const tokenElement = document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement;
        let token = tokenElement.value;
        let headers = new Headers();
        headers.append(contentTypeKey, "application/json");
        headers.append(RequestVerificationTokenKey, token);

        const response = await fetch(apiUrl, {
            method: 'post',
            headers: headers,
            body: JSON.stringify(payload)
        });

        if (response.ok) {
            const responsedata = await response.json();
            let status = responsedata.status;

            if (status == 200) {
                isOtpSent = true;
            } else {
                onErrorAction(unknownErrorMessage);
            }

            hideSpinner(spinnerDiv);
        } else {
            const responsedata = await response.json();
            const controllerApiErrorKey = "controllerApiError";
            var errorMessage;

            if (controllerApiErrorKey in responsedata) {
                errorMessage = responsedata[controllerApiErrorKey];
            }
            else {
                errorMessage = unknownErrorMessage;
            }
            onErrorAction(errorMessage);
        }
    }
    catch (error) {
        onErrorAction(unknownErrorMessage);
    }

    hideSpinner(spinnerDiv);
    return isOtpSent;
}

export async function postValidateOtpPinAsync(
    billingAccount: string,
    authenticationMethod: string,
    otpOrPin: string) {
    const spinnerDiv = document.getElementById("spinner") as HTMLDivElement;
    const payload = {
        AuthMethod: authenticationMethod,
        BillingAccount: billingAccount,
        OtpCodePIN: otpOrPin
    };
    const apiUrl = '/api/Mfa/ValidateOtpPin';
    const contentTypeKey = "Content-Type";
    const RequestVerificationTokenKey = "RequestVerificationToken";
    const tokenElement = document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement;
    let token = tokenElement.value;
    let headers = new Headers();
    headers.append(contentTypeKey, "application/json");
    headers.append(RequestVerificationTokenKey, token);
    showSpinner(spinnerDiv);

    try {
        await refreshAntiForgeryTokenAsync();

        const response = await fetch(apiUrl, {
            method: 'post',
            headers: headers,
            body: JSON.stringify(payload)
        });

        if (response.ok) {
            const responsedata = await response.json();
            let status = responsedata.status;

            if (status == 200) {
                getBalanceAsync(billingAccount);
            } else {
                let authType = (authenticationMethod == AuthenticationMethod.Pin) ? "Pin" : "code";
                onErrorAction("Invalid " + authType + ", please try again.");
            }

            hideSpinner(spinnerDiv);
        }
        else {
            const responsedata = await response.json();
            const controllerApiErrorKey = "controllerApiError";
            var errorMessage;

            if (controllerApiErrorKey in responsedata) {
                errorMessage = responsedata[controllerApiErrorKey];
            }
            else {
                errorMessage = unknownErrorMessage;
            }
            onErrorAction(errorMessage);
        }
    }
    catch (error) {
        onErrorAction(unknownErrorMessage);
    }
}

export async function refreshAntiForgeryTokenAsync() {
    try {
        const apiUrl = '/api/Balance/GetNewToken'
        const response = await fetch(apiUrl, {
            method: 'GET',
            credentials: 'include'
        });

        const token = await response.text();
        const antiForegeryTokenElement =
            document.querySelector<HTMLInputElement>('[name = "__RequestVerificationToken"]');

        if (antiForegeryTokenElement) {
            antiForegeryTokenElement.value = token;
        }
    }
    catch (error) {
        console.error('Error:', error);
    }
}
